module.exports = __webpack_public_path__ + "images/made-wth-react-8ab12c496de37bfd940ae032c64aafa4.png";